import { Collapsible as ChakraCollapsible, CollapsibleRootProps, Flex } from '@chakra-ui/react'
import { forwardRef } from 'react'
import { Text } from '.'
import { ChevronDownIcon } from './icons'

export interface Props extends Omit<CollapsibleRootProps, 'children' | 'onOpenChange'> {
  children: React.ReactNode
  defaultOpen?: boolean
  label?: JSX.Element | string
  onOpenChange?: (open: boolean) => void
}

export default forwardRef<HTMLDivElement, Props>(function Collapsible(
  { children, defaultOpen, label, onOpenChange, ...rest },
  ref
) {
  return (
    <ChakraCollapsible.Root
      ref={ref}
      defaultOpen={defaultOpen}
      onOpenChange={p => onOpenChange?.(p.open)}
      {...rest}
    >
      {label && (
        <ChakraCollapsible.Trigger asChild>
          <Flex
            alignItems="center"
            justifyContent="space-between"
            cursor="pointer"
            _open={{ '& svg': { transform: 'rotateX(-180deg)' } }}
          >
            {typeof label === 'string' ? (
              <Text userSelect="none" textStyle="bodyMedium">
                {label}
              </Text>
            ) : (
              label
            )}
            <ChevronDownIcon size="sm" transition="all 300ms" />
          </Flex>
        </ChakraCollapsible.Trigger>
      )}

      <ChakraCollapsible.Content>{children}</ChakraCollapsible.Content>
    </ChakraCollapsible.Root>
  )
})
